import { Title } from 'components'
import { useCurrentUser } from 'context/useCurrentUser'
import { useArcTranslation } from 'hooks'

/** Renders the dashboard welcome line, degrading gracefully if the name is missing. */
export const ManagerGreeting = () => {
  const { t } = useArcTranslation()
  const { currentUser } = useCurrentUser()
  const fullName = currentUser?.full_name?.trim()

  const greeting = fullName
    ? t('manager_dashboard.greeting_named', { name: fullName })
    : t('manager_dashboard.greeting')

  return (
    <Title order={1} size='h3'>
      {greeting}
    </Title>
  )
}
